module.exports = __webpack_public_path__ + "img/a1-5.bc9210a9.png";